export { SharedService } from './shared.service';
export {AnalyticsHandler} from './app.analytics.setup';
export {PWAService} from './pwa.service';
export { PixelHandler } from './app.fbpixel.setup';
export {QRScannerService} from './qr-scanner.service';
export {GoogleTagManagerHandler} from './app.tag-manager.setup';